export default __webpack_public_path__ + "static/media/sunbelt.3ff32278.png";